import type { Block, EmailDocument } from "../domain/types";
import { blockHasColumnOverflowInDocument } from "../domain/column-content-min";

export const ROW_SETTINGS_DEFAULT_EXPANDED = ["layout"] as const;
export const COLUMN_SETTINGS_DEFAULT_EXPANDED = ["alignment", "padding", "appearance"] as const;
export const GROUP_SETTINGS_DEFAULT_EXPANDED = ["padding"] as const;
export const BUTTON_ROW_SLOT_SETTINGS_DEFAULT_EXPANDED = ["content"] as const;
export const APPEARANCE_NESTED_DEFAULT_EXPANDED = ["appearance-background"] as const;

const TEXT_BLOCK_SETTINGS_DEFAULT_EXPANDED = ["typography", "layout"] as const;
const DIVIDER_BLOCK_SETTINGS_DEFAULT_EXPANDED = ["layout", "appearance"] as const;
const EYEBROW_BLOCK_SETTINGS_DEFAULT_EXPANDED = ["layout", "appearance"] as const;
const SOCIAL_BLOCK_SETTINGS_DEFAULT_EXPANDED = ["content", "layout"] as const;
const IMAGE_BLOCK_SETTINGS_DEFAULT_EXPANDED = ["content", "layout"] as const;
const BUTTON_BLOCK_SETTINGS_DEFAULT_EXPANDED = ["content", "layout"] as const;
const CONTENT_BLOCK_SETTINGS_DEFAULT_EXPANDED = ["content"] as const;
const LAYOUT_BLOCK_SETTINGS_DEFAULT_EXPANDED = ["layout"] as const;
const SPACER_BLOCK_SETTINGS_DEFAULT_EXPANDED = ["size"] as const;

export function resolveBlockSettingsDefaultExpandedSections(
  blockType: Block["type"],
): readonly string[] {
  switch (blockType) {
    case "text":
      return TEXT_BLOCK_SETTINGS_DEFAULT_EXPANDED;
    case "social":
      return SOCIAL_BLOCK_SETTINGS_DEFAULT_EXPANDED;
    case "divider":
      return DIVIDER_BLOCK_SETTINGS_DEFAULT_EXPANDED;
    case "image":
      return IMAGE_BLOCK_SETTINGS_DEFAULT_EXPANDED;
    case "eyebrow":
      return EYEBROW_BLOCK_SETTINGS_DEFAULT_EXPANDED;
    case "button":
      return BUTTON_BLOCK_SETTINGS_DEFAULT_EXPANDED;
    case "buttonRow":
      return LAYOUT_BLOCK_SETTINGS_DEFAULT_EXPANDED;
    case "spacer":
      return SPACER_BLOCK_SETTINGS_DEFAULT_EXPANDED;
    default:
      return CONTENT_BLOCK_SETTINGS_DEFAULT_EXPANDED;
  }
}

export function resolveBlockSettingsExpandedSections(
  document: EmailDocument,
  rowId: string,
  block: Block,
): readonly string[] {
  const sections = [...resolveBlockSettingsDefaultExpandedSections(block.type)];
  if (
    blockHasColumnOverflowInDocument(document, rowId, block.id) &&
    !sections.includes("layout")
  ) {
    sections.push("layout");
  }
  return sections;
}
